// Footer Component
// Final section with copyright and additional links

import React from 'react';
import './Footer.css';
import Logo from './Logo';
import { getSocialLinksForContact } from '../utils/socialLinksHelper';
import versionData from '../data/version.json';
import { useCanvasAnimation } from '../hooks/useCanvasAnimation';
import { getFooterContent } from '../utils/contentLoader';

function Footer() {
  const { canvasRef, containerRef } = useCanvasAnimation();

  return (
    <footer className="footer" ref={containerRef}>
      <canvas ref={canvasRef} className="footer-canvas" />
      <div className="footer-container">
        <div className="footer-content">
          {/* Logo and branding */}
          <div className="footer-brand">
            <Logo />
            <p className="footer-tagline">
              {getFooterContent().tagline || "Building a better world through crypto"}
            </p>
          </div>

          {/* Quick links */}
          <div className="footer-links">
            <h4 className="footer-heading">{getFooterContent().quickLinks?.title || "Quick Links"}</h4>
            {getFooterContent().quickLinks?.links?.map((link, index) => (
              <a key={index} href={link.href} className="footer-link">{link.text}</a>
            ))}
          </div>

          {/* Additional info */}
          <div className="footer-info">
            <h4 className="footer-heading">{getFooterContent().connect?.title || "Connect"}</h4>
            {/* Show social links from socials section (same as Socials component) */}
            {getSocialLinksForContact().map((social, index) => (
              <a 
                key={index}
                href={social.url} 
                target="_blank" 
                rel="noopener noreferrer"
                className="footer-link"
              >
                {social.displayName}
              </a>
            ))}
          </div>
        </div>

        {/* Copyright */}
        <div className="footer-bottom">
          <p className="footer-copyright">
            {(getFooterContent().copyright || "© {year} HomeMetaX. All rights reserved.").replace('{year}', new Date().getFullYear())}
          </p>
          <p className="footer-note">
            {getFooterContent().note || "Made with ❤️ for the Web3 community"} • <span style={{color: '#8DFFA4', fontWeight: '600'}}>v{versionData.version}</span>
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;

